import Int32LookupRequestListResultModel from '../../generated/types/model/resource/Int32LookupRequestListResultModel';

export default class Int32LookupRequestListResultViewModel extends Int32LookupRequestListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
